import Main from '@/views/common/main'
// 账户管理中心
export default [
    //'系统管理'
    {
        path: '/log',
        name: 'log',
        meta: {
            icon: 'ios-apps',
            title: '日志管理'
        },
        component: Main,
        children: [
            // 活跃管理
            {
                path: 'OperationLog',
                name: 'log_OperationLog',
                meta: { title: '运营后台操作日志' },
                component: () => import('@/views/log/OperationLog.vue')
            },
            // 红包管理
            {
                path: 'userLog',
                name: 'log_userLog',
                meta: { title: '玩家操作日志' },
                component: () => import('@/views/log/userLog.vue')
            },
            // 标签管理
            {
                path: 'ysLog',
                name: 'log_ysLog',
                meta: { title: '银商后台操作日志' },
                component: () => import('@/views/log/ysLog.vue')
            }
        ]
    }
]
// 数据报表
